import React from 'react';
import { Button, DatePicker, Progress } from 'antd';
import SearchFilter from '../filters/SearchFilter';
import Main from '../../Pages/Demo/main';
import { Input } from '@progress/kendo-react-inputs';
import Lang from '../../lang'
import services from '../../services';
import LeventoCards from './LeventoCards';
import { toast } from 'react-toastify';
var moment = require('moment')

const filters = {
    Tabs: {
        Enquadramento: [
            {
                key: 'tipodireito',
                displayKey: "Tipo direito",
                inputType: "text"
            },
            {
                key: 'geocod',
                displayKey: "Código direito",
                inputType: "text"
            }
        ]
    },
    checkbox: [

    ]
}

let combolistrequest = {
    "Filters": null,
    "SortBy": "nif",
    "IsSortTypeDESC": true,
    "IsPagination": true,
    "Page": 1,
    "PageSize": 20
};

class MatrixModalForm extends React.Component {
    /* Primeiro passo na acomodação da classe */

    constructor(props) {
        super(props);
        this.state = {
            data: [],
            date:this.props.date,
            filterData: [],
            leventamentoArray: [],
            typeFilter: 'nif',
            error:null
        }
    }

    /* Esta é a primeira etapa após o construxctor para carregar este componente  */

    componentDidMount() {
        this.setState({
            data: [],
            filterData: []
        }, () => this.getLevantamento(null));
    }

    componentDidUpdate(preProps){
        if(preProps.date !==  this.props.date){
            this.setState({
                date:this.props.date,
                data: [],
                filterData: []
            })
        }
     }






    getLevantamento = async (filters) => {
        try {
            if (filters && filters.filters) {
                filters.filters.nif ="" +filters.filters.nif ? parseInt(filters.filters.nif) : null
                filters.filters.nrvitic ="" + filters.filters.nrvitic ? parseInt(filters.filters.nrvitic) : null
                combolistrequest.Filters = filters.filters
            }
            if(!combolistrequest.Filters || 
                (combolistrequest.Filters && 
                (Object.keys(combolistrequest.Filters).length == 0 || 
                (!combolistrequest.Filters.nif && !combolistrequest.Filters.nrvitic 
                    && !combolistrequest.Filters.tipodireito && !combolistrequest.Filters.geocod)
                ))){
                this.setState({
                    data: [],
                    filterData: []
                })
                return
            }
            // combolistrequest.Filters.nif= ""+combolistrequest.Filters.nif;
            let res = await services.apiCall.requestApi("Levantamento/GetAll", combolistrequest, 'post');
            if (res) {
                if(res.length===0){
                    toast.error("Nenhum Registo Encontrado");
                }
                this.setState({
                    data: res,
                    filterData: res
                })
            }
        } catch (error) {
            this.setState({error})
        }
    }

    handleSubmit = () => {
        //  this.props.getpopUpdata(this.state.data,this.props.tab)
    }

    /* Obter a chave do filtro do filtro personalizado */

    getFilters(filter) {
        this.getLevantamento(filter);
    }

    handleRadioTypeFilter = (e) => {
        this.setState({
            typeFilter: e.target.value
        })
    }

    getLevantamentoRow = (state) => {
        let data = this.props.data;
        if (!data || !Array.isArray(data))
            data = [];
        let error = null;
        if (state.areaapporto == null)
            toast.error("areaapporto é necessário");
        else if (state.areaapdouro == null)
            toast.error("areaapdouro é necessário");
        else {

            let newLegal = {
                "legalFrameworks": {
                    "iddtplantacao": state.row.geocod,
                    "iddtorigem": state.row.codigo,
                    "tipo": null, //pending
                    "areaapdouro": state.areaapdouro,
                    "areaapporto": state.areaapporto,
                    "obs": state.obs,
                    "disponivel": false,
                    "tipoha": null,//pending
                    "predioarranque": null, //pending
                },
                "levantamento": [state.row]
            }

            data.push(newLegal)
            this.props.getpopUpdata(data, this.props.tab);
            this.props.closePopup();
        }

        ////console.log('data.........',state);
        ////console.log('state......', this.props.tab)

    }

    /* Para obter dados filtrados do componente de filtro personalizado  */

    handleFilter = (data) => {
        //     //console.log("data",data)
        //    if(data && data.length > 0){
        //         this.setState({
        //             filterData : data
        //         })
        //    }
    }

    handleChange = (e, row) => {
        try {
            let filterData = [...this.state.data];
            filterData.map(_row => {
                if (_row.idenqlegal && _row.idenqlegal === row.idenqlegal) {
                    _row[e.target.name] = e.target.value
                }
            })
            this.setState({
                data: filterData
            }, () => this.handleFilter(this.state.data))
        } catch (error) {
            this.setState({error})
        }

        //console.log("LEGALFRAMEWORK", filterData)
    }

    /*  Para renderizar o conteúdo html da página   */
    closePopup=()=>{
        this.setState({
            data:[],
            filterData:[]
        },()=>{
            this.props.closePopup()
        })
    }
    render() {
        if(this.state.error){
            throw this.state.error;
        }
        return (
            <div className="modal-content">
                <div className="modal-header">
                    <h4 className="modal-title pl-0">Aplicar direitos</h4>
                    <Button className="mr-2 k-primary k-button btn-ivdp-primary cursor-pointer" onClick={() => this.closePopup()}>Fechar</Button>
                </div>
                <div className="modal-body">
                    <div className="details">
                        <div>
                            <div className="custom-control custom-radio custom-control-inline">
                                <input type="radio" defaultChecked={true} onClick={(e) => this.handleRadioTypeFilter(e)} className="custom-control-input" id="customRadio" name="example" value="nif" />
                                <label className="custom-control-label" htmlFor="customRadio">NIF</label>
                            </div>
                            <div className="custom-control custom-radio custom-control-inline">
                                <input type="radio" onClick={(e) => this.handleRadioTypeFilter(e)} className="custom-control-input" id="customRadio2" name="example" value="nrvitic" />
                                <label className="custom-control-label" htmlFor="customRadio2"><p>N<span lang="pt-PT"><sup><u>&ordm;</u></sup></span> Viticultor</p></label>
                            </div>
                        </div>
                        <div className="model-search">
                            <SearchFilter date={this.state.date} typeFilter={this.state.typeFilter} filters={filters} leftside={false} handleFilter={(data) => this.handleFilter(data)} data={this.state.data} getFilter={(data) => this.getFilters(data)} />
                            {
                                this.state.data &&
                                this.state.data.map((_r, i) => (

                                    <LeventoCards key={i} index={i} row={_r} getLevantamentoRow={(state) => this.getLevantamentoRow(state)} />
                                ))
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
        //  }
    }
}

export default MatrixModalForm;